/**
 * Skip-to-content link (APP-001 §25).
 *
 * First focusable element in the layout. Hidden until focused, then visible,
 * letting keyboard users jump directly to main content.
 */
import { cn } from '@/lib/utils';

export function SkipLink({ targetId = 'main-content', className }: { targetId?: string; className?: string }) {
  return (
    <a
      href={`#${targetId}`}
      className={cn(
        'sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[100] focus:rounded-md focus:bg-primary focus:px-4 focus:py-2 focus:text-sm focus:font-medium focus:text-primary-foreground',
        className,
      )}
    >
      Skip to content
    </a>
  );
}
